import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
  faDotCircle,
  faPlus
} from '@fortawesome/free-solid-svg-icons';

const Toolbar = ({
  label,
  onNavigate,
  onView,
  views,
  view,
  onToggleMenu,
  onAddButtonClick
}) => {
  const vueLabel = {
    month: 'Mois',
    day: 'Jour',
    agenda: 'Agenda'
  };

  return (
    <div className="rbc-toolbar">
      <div className="toolbar-label-with-buttons">
        <button onClick={() => onNavigate('PREV')} title="Précédent">
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>
        <button onClick={() => onNavigate('TODAY')} title="Aujourd'hui">
          <FontAwesomeIcon icon={faDotCircle} />
        </button>
        <button onClick={() => onNavigate('NEXT')} title="Suivant">
          <FontAwesomeIcon icon={faChevronRight} />
        </button>
        <span className="rbc-toolbar-label">{label}</span>
      </div>

      <div className="toolbar-navigation-right">
        <button className="add-event-btn" onClick={onAddButtonClick}>
          <FontAwesomeIcon icon={faPlus} />
        </button>

        {Array.isArray(views) &&
          views.map((v) => (
            <button
              key={v}
              className={view === v ? 'active' : ''}
              onClick={() => onView(v)}
            >
              {vueLabel[v] || v}
            </button>
          ))}
      </div>
    </div>
  );
};

export default Toolbar;